import { render } from "./LogbookBankDepositSEFPage.vue?vue&type=template&id=59fbc01c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__